import apiClient from './apiClient';

export interface AdminNote {
  _id: string;
  user: {
    _id: string;
    username: string;
    name: string;
  };
  admin: {
    _id: string;
    username: string;
    name: string;
    email?: string;
  };
  note: string;
  isInternal: boolean;
  tags?: string[];
  priority?: 'low' | 'normal' | 'high' | 'urgent';
  createdAt: string;
  updatedAt: string;
}

class AdminNoteService {
  async getUserNotes(userId: string, priority?: string, tag?: string): Promise<AdminNote[]> {
    const params = new URLSearchParams();
    if (priority) params.append('priority', priority);
    if (tag) params.append('tag', tag);
    const query = params.toString();
    const response = await apiClient.get(`/admin/notes/user/${userId}${query ? `?${query}` : ''}`);
    return response.data.data;
  }

  async getAllNotes(params?: {
    page?: number;
    limit?: number;
    userId?: string;
    priority?: string;
    tag?: string;
  }): Promise<{ notes: AdminNote[]; pagination: any }> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.userId) queryParams.append('userId', params.userId);
    if (params?.priority) queryParams.append('priority', params.priority);
    if (params?.tag) queryParams.append('tag', params.tag);
    const query = queryParams.toString();
    const response = await apiClient.get(`/admin/notes${query ? `?${query}` : ''}`);
    return response.data.data;
  }

  async createNote(userId: string, noteData: {
    note: string;
    tags?: string[];
    priority?: 'low' | 'normal' | 'high' | 'urgent';
    isInternal?: boolean;
  }): Promise<AdminNote> {
    const response = await apiClient.post(`/admin/notes/user/${userId}`, noteData);
    return response.data.data;
  }

  async updateNote(noteId: string, noteData: {
    note?: string;
    tags?: string[];
    priority?: 'low' | 'normal' | 'high' | 'urgent';
    isInternal?: boolean;
  }): Promise<AdminNote> {
    const response = await apiClient.put(`/admin/notes/${noteId}`, noteData);
    return response.data.data;
  }

  async deleteNote(noteId: string): Promise<void> {
    await apiClient.delete(`/admin/notes/${noteId}`);
  }
}

export const adminNoteService = new AdminNoteService();
export default adminNoteService;


